// @flow

export default (number: string) => `tel:${number.replace(/(^\+{1})|(\D)/g, '$1')}`;
